<p-toast></p-toast>
<div class="global-title-bar">
    <h2 class="global-title">
        PDF Templates - Bookings, Leads, Header & Footer
    </h2>
</div>
<div *ngIf="pdfTemplateService.activeItemId != null && pdfTemplateService.activeItemId != undefined">
    <div class="nav-bar">
        <p-button label="Add template for Booking" (click)="createBookingDocumentTemplate()"></p-button>
        <p-button label="Add template for lead" (click)="createContactRequestDocumentTemplate()"></p-button>
        <p-selectButton [options]="pdfTemplateService.languages" optionLabel="name"
            [(ngModel)]="pdfTemplateService.selectedLanguage" (onChange)="updateTemplates()"></p-selectButton>
    </div>
    <p-tabMenu [model]="pdfTemplateService.navigationItems" [activeItem]="pdfTemplateService.activeItem"></p-tabMenu>

    <app-pdf-templates-booking-related *ngIf="pdfTemplateService.activeItemId==viewOption.BOOKING_RELATED">
    </app-pdf-templates-booking-related>
    <app-pdf-templates-lead-related *ngIf="pdfTemplateService.activeItemId==viewOption.CONTACT_REQUEST_RELATED">
    </app-pdf-templates-lead-related>
    <app-pdf-templates-header-footer *ngIf="pdfTemplateService.activeItemId==viewOption.HEADER_FOOTER">
    </app-pdf-templates-header-footer>

    <app-booking-pre-confirmation-templates *ngIf="pdfTemplateService.activeItemId==viewOption.PRE_CONFIRMATION">
    </app-booking-pre-confirmation-templates>
    <app-booking-pre-confirmation-template-edit *ngIf="pdfTemplateService.activeItemId==viewOption.EDIT_PRE_CONFIRMATION"></app-booking-pre-confirmation-template-edit>
    <app-pdf-template-edit *ngIf="pdfTemplateService.activeItemId==viewOption.EDIT_BOOKING_RELATED">
    </app-pdf-template-edit>
    <app-pdf-template-create *ngIf="pdfTemplateService.activeItemId==viewOption.CREATE_BOOKING_RELATED">
    </app-pdf-template-create>
    <app-create-wp-contact-request-pdf-template
        *ngIf="pdfTemplateService.activeItemId==viewOption.CREATE_CONTACT_REQUEST_RELATED">
    </app-create-wp-contact-request-pdf-template>
    <app-edit-wp-contact-request-pdf-template
        *ngIf="pdfTemplateService.activeItemId==viewOption.EDIT_CONTACT_REQUEST_RELATED">
    </app-edit-wp-contact-request-pdf-template>
    <app-pdf-document-header-footer-edit *ngIf="pdfTemplateService.activeItemId==viewOption.EDIT_HEADER_FOOTER">
    </app-pdf-document-header-footer-edit>
    <app-booking-final-confirmation-templates *ngIf="pdfTemplateService.activeItemId==viewOption.FINAL_CONFIRMATIONS"></app-booking-final-confirmation-templates>
    <app-booking-final-confirmation-template-edit *ngIf="pdfTemplateService.activeItemId==viewOption.EDIT_FINAL_CONFIRMATION"></app-booking-final-confirmation-template-edit>
    <app-booking-confirmation-templates *ngIf="pdfTemplateService.activeItemId==viewOption.CONFIRMATIONS"></app-booking-confirmation-templates>
    <app-booking-confirmation-template-edit *ngIf="pdfTemplateService.activeItemId==viewOption.EDIT_CONFIRMATION"></app-booking-confirmation-template-edit>
</div>